module.exports = __webpack_public_path__ + "img/default-gallery.f92af266.jpg";